import { render, staticRenderFns } from "./CreateTemplateFromOrder.vue?vue&type=template&id=28778858&"
import script from "./CreateTemplateFromOrder.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateFromOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports